import Vue from "vue";
import Router from "vue-router";

import Home from "./views/Home.vue";
import Synthesis from "./views/Synthesis";
import Contribution from "./views/Contribution";
import Ground from "./views/Ground";
import Recommendation from "./views/Recommandation";
import Repport from "./views/Repport";
import Yield from "./views/Yield";
import Ze404 from "./views/Ze404";
import Help from "./views/Help";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      component: Home,
      order: 0,
      libelle: "route_home",
      icon: "home",
      enabled: true
    },
    {
      path: "/rendement",
      component: Yield,
      order: 1,
      libelle: "route_yield",
      icon:"looks_one",
      enabled: true
    },
    {
      path: "/apports",
      component: Contribution,
      order: 2,
      libelle: "route_contribution",
      icon: "looks_two",
      enabled: false
    },
    {
      path: "/sol",
      component: Ground,
      order: 3,
      libelle: "route_ground",
      icon: "looks_3",
      enabled: false
    },
    {
      path: "/synthese",
      component: Synthesis,
      order: 4,
      libelle: "route_synthesis",
      icon: "looks_4",
      enabled: false
    },
    {
      path: "/preconisation",
      component: Recommendation,
      order: 5,
      libelle: "route_recommendation",
      icon: "looks_5",
      enabled: false
    },
    {
      path: "/repport",
      component: Repport,
      order: 9,
      libelle: "",
      icon: "",
      enabled: false
    },
    // {
    //   path: "/about",
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () =>
    //     import(/* webpackChunkName: "about" */ "./views/About.vue"),
    //   order: 6,
    //   libelle: "route_about",
    //   icon: "",
    //   enabled: true
    // },

    {
      path: "/aide/:idNode",
      component: Help,
      order: 7,
      libelle: "",
      icon: "",
      enabled: false
    },
    {
      path: "/aide/1028",
      component: Help,
      order: 6,
      libelle: "route_about",
      icon: "",
      enabled: true
    },
    {
      path: "*",
      component: Ze404,
      order: 8,
      libelle: "",
      icon: "",
      enabled: false
    }
  ]
});
